import { render, staticRenderFns } from "./LayoutElementsList.vue?vue&type=template&id=3288f244&scoped=true"
import script from "./LayoutElementsList.vue?vue&type=script&lang=js"
export * from "./LayoutElementsList.vue?vue&type=script&lang=js"
import style0 from "./LayoutElementsList.vue?vue&type=style&index=0&id=3288f244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3288f244",
  null
  
)

export default component.exports